/** Экспортируем NAME из отдельного файла, чтобы использовать его в .public и при этом не получить пробелем с браузерным API на сервере */
export const __NAME__ = '__APP_CONFIG__'
